// Emitted by the app-version plugin in vite.config.mjs on every build: { "version": "<build id>" }.
export const APP_VERSION_URL = '/version.json';

// Build id of the bundle running in this tab (same plugin). Empty in dev — the check is off there.
export const CURRENT_APP_VERSION = import.meta.env.VITE_APP_VERSION ?? '';

// How often an open tab looks for a new deploy.
export const APP_VERSION_CHECK_INTERVAL_MS = 5 * 60 * 1000;

// Returning to the tab also checks, but not more often than this.
export const APP_VERSION_FOCUS_CHECK_MIN_GAP_MS = 60 * 1000;

// A dismissed notice comes back after this long while the tab still runs the old version.
export const APP_UPDATE_REMIND_AFTER_MS = 30 * 60 * 1000;
